import { useAppSelector } from "redux-share/hooks";
import ClockIcon from "../../components/icon-components/clockIcon";
import { shallowEqual } from 'react-redux'
import { conditions, secondsToHMS } from "helpers";
import InfoIcon from "../../components/icon-components/infoIcon";
import useContinuousePlaybackTimer from "./hooks/useContinuousePlaybackTimer";
import { ConditionName } from "interfaces";
import { handleGoToFirstVideo, handleShowContinuousVideo } from "./continuousePlayback";

const ContinuousPlayback = () => {

    const { videoSettings } = useAppSelector(({ user: { videoSettings } }) => ({ videoSettings }), shallowEqual);
    const timer = useContinuousePlaybackTimer();

    return (
        <div className="pl-w-full pl-h-full pl-flex pl-flex-col pl-justify-center pl-items-center pl-absolute pl-bg-white/[0.8] dark:pl-bg-dark-1/[0.8] pl-px-6">
            <div className={`pl-w-full pl-flex ${conditions(ConditionName.isComplexPortrait) ? "pl-items-center pl-pb-3 pl-mb-[10px]" : "pl-flex-col pl-pb-6 pl-mb-[20px]"} pl-justify-center pl-items-center pl-border-b pl-border-secondary dark:pl-border-z-secondary-600`}>
                <ClockIcon className="pl-w-5 pl-h-5 pl-fill-z-secondary-600 dark:pl-fill-z-secondary-500" />
                <p className={`pl-text-gray-800 dark:pl-text-white pl-text-[20px] pl-font-bold ${conditions(ConditionName.isComplexPortrait) ? "pl-order-3 pl-mr-auto" : "pl-mt-3 pl-mb-1"}`}>{secondsToHMS(videoSettings.time)}</p>
                <p className={`pl-font-normal pl-text-gray-800 ${conditions(ConditionName.isComplexPortrait) ? "pl-mr-1 dark:pl-text-white pl-text-[16px]" : "dark:pl-text-secondary pl-text-[12px]"}`}>زمان مشاهده قبلی</p>
            </div>
            <div className="pl-w-full pl-flex pl-gap-2 pl-items-start">
                <InfoIcon className="pl-fill-main dark:pl-fill-main-lightPurple" />
                <p className="pl-text-[14px] pl-font-medium pl-text-gray-800 dark:pl-text-white pl-flex-1">ویدیو شما از زمان مشاهده قبلی پخش خواهد شد. در صورت تمایل به پخش ویدیو از ابتدا گزینه “تماشای ویدیو از ابتدا” را انتخاب کنید.</p>
            </div>
            <form className={`pl-flex pl-gap-2 pl-w-full ${conditions(ConditionName.isComplexPortrait) ? "pl-mt-5" : "pl-mt-10"} `}>
                <button
                    type="submit"
                    className="!pl-bg-main-light hover:!pl-bg-main-700 pl-transition-colors pl-duration-300 pl-rounded-[8px] pl-py-3 pl-text-white pl-text-[13px] pl-w-full"
                    onClick={handleShowContinuousVideo}
                >
                    تماشای ادامه ویدیو ({timer})
                </button>
                <button
                    type="button"
                    className="pl-border-[1.5px] pl-border-secondary-400 pl-transition-colors pl-duration-300 pl-rounded-[8px] pl-py-3 pl-text-secondary-600 dark:pl-text-white pl-text-[13px] pl-w-full"
                    onClick={handleGoToFirstVideo}
                >
                    تماشای ویدیو از ابتدا
                </button>
            </form>
        </div>
    )
}

export default ContinuousPlayback;